module.exports = {"210102001":"浑河湾街道","210102002":"新华街道","210102007":"西塔街道","210102013":"八经街道","210102016":"马路湾街道","210102017":"集贤街道","210102019":"南湖街道","210102021":"长白街道","210102022":"太原街街道","210102023":"北市场街道","210102025":"南市场街道","210102027":"沈水湾街道","210102028":"浑河站西街道"}


//////////////////
// WEBPACK FOOTER
// ./src/town/210102.json
// module id = 452
// module chunks = 0